import { combineEpics } from 'redux-observable';
import { ContactPermission, ReduxAction } from '@repo/utils/types';
import { createSharingActions, createSharingEpicActionCreators, createSharingEpics } from './utils';
import AppState from '../../reducers/app-state';

const actionCreators = createSharingEpicActionCreators('CONTACT');

export const {
  fetchShareStatus: fetchContactShareStatus,
  shareWithEmail: shareContactWithEmail,
  unshareWithSharee: unshareContactWithSharee,
  addPermissionForSharee: addContactPermissionForSharee,
  removePermissionForSharee: removeContactPermissionForSharee,
  sharePublicly: shareContactPublicly,
  unsharePublicly: unshareContactPublicly,
  addPublicPermission: addContactPublicPermission,
  removePublicPermission: removeContactPublicPermission,
} = createSharingActions<ContactPermission>('CONTACT', actionCreators);

export const contactShareStatusesEpic = combineEpics<ReduxAction, any, AppState>(
  ...createSharingEpics('CONTACT', actionCreators),
);
